import { data } from '../../svg/Partnering/data';
import { makeIcon } from '../makeIcon';

export const Partnering = makeIcon(data, 'partnering', 'Partnering');

export default Partnering;
